var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6592 17.6079L11.8352 12.6639H5.21122L3.38722 17.6079H0.699219L7.20322 0.399902H9.89122L16.3712 17.6079H13.6592ZM9.38722 5.5839C9.33922 5.4079 9.25122 5.1439 9.12322 4.7919C9.01122 4.4239 8.89922 4.0559 8.78722 3.6879C8.67522 3.3039 8.58722 2.9919 8.52322 2.7519C8.44322 3.0719 8.34722 3.4239 8.23522 3.8079C8.13922 4.1759 8.04322 4.5199 7.94722 4.8399C7.85122 5.1439 7.77122 5.3919 7.70722 5.5839L5.97922 10.4079H11.1152L9.38722 5.5839Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.febffdf6ae7d46e80ad7df1d9475511f.svg";
export { ForwardRef as ReactComponent };